/* src/app/shared/ui-kit/pa-table/pa-table.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.pa-table-container.overflow-auto {
  overflow: auto;
}
.pa-table-container,
.pa-table-skeleton {
  flex: 1 1 auto;
  overflow: hidden;
  width: 100%;
}
.pa-table-view {
  height: 100%;
}
.pa-table-view .pa-table-wrapper {
  height: 100%;
}
.pa-table-view .cell.with-hover-arrow {
  position: relative;
  cursor: pointer;
}
.pa-table-view .cell.with-hover-arrow .cell-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
}
.pa-table-view .cell.with-hover-arrow .hover-arrow {
  opacity: 0;
  transition: opacity 0.2s ease, transform 0.2s ease;
  color: var(--secondary-subtle-inverse);
  font-size: 14px;
  flex-shrink: 0;
  transform: translateX(-4px);
}
.pa-table-view tr:hover .cell.with-hover-arrow .hover-arrow {
  opacity: 1;
  transform: translateX(0);
}
.pa-table-cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1rem;
}
@media (max-width: 768px) {
  .pa-table-cards-container {
    grid-template-columns: 1fr;
  }
}
.pa-table-grouped-cards-container {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 0;
  column-gap: 16px;
}
.pa-table-grouped-cards-container .pa-table-card {
  margin-bottom: 16px !important;
}
.pa-table-card {
  background: var(--contrast-inverse);
  border-radius: 20px;
  padding: 16px;
  border: 1px solid var(--secondary-subtle-hover);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  overflow-wrap: break-word;
  word-break: break-word;
}
.pa-table-group-card-header {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  cursor: pointer;
}
.pa-table-group-card-header-text {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.pa-table-group-card-header-text .pa-table-group-card-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: var(--text-default);
}
.pa-table-group-card-header-text .pa-table-group-card-subtitle {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--text-default);
}
.pa-table-group-card-toggle {
  min-width: 32px;
  height: 32px;
}
.pa-table-group-card-actions {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}
.pa-table-card-content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.pa-table-checkbox-column,
.pa-table-actions-column {
  text-align: center;
}
.pa-table-loading {
  position: relative;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pa-table-loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  color: var(--p-primary-color, #3b82f6);
}
.pa-table-loading-spinner i {
  font-size: 2rem;
}
.pa-table-loading-spinner span {
  font-size: 0.875rem;
  color: var(--p-text-secondary-color, #6b7280);
}
.cell {
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.cell .cell-header {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.cell .cell-header .pi-question-circle {
  font-size: 14px;
  color: var(--secondary-subtle-inverse);
}
.cell .content-text {
  line-height: 22px;
  font-size: 16px;
  font-weight: 400;
  color: var(--text-default);
}
td.cell {
  cursor: pointer;
}
.pa-table-card-header {
  display: flex;
  margin-bottom: 0.75rem;
  min-height: 32px;
  justify-content: space-between;
  align-items: baseline;
}
.pa-table-card-header-left {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.pa-table-card-header-right {
  display: flex;
  align-items: center;
}
.card-checkbox {
  padding-right: 16px;
}
.card-title {
  font-size: 20px;
  margin: 0;
  font-weight: 500;
  line-height: 28px;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  cursor: pointer;
}
.info-list {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  gap: 16px;
  border-radius: 8px;
  color: var(--ion-text-color);
  max-width: 400px;
}
.info-list .info-item {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.info-list .info-item .info-text .label {
  font-weight: bold;
  font-size: 1rem;
}
.info-list .info-item .info-text .value {
  font-size: 1rem;
  margin-top: 0.2rem;
}
.info-list .info-item .icon {
  font-size: 1rem;
  background-color: var(--secondary-subtle-default);
  padding: 1rem;
  border-radius: 8px;
  font-size: 20px;
}
::ng-deep .p-datatable .p-datatable-tbody > tr:hover {
  background-color: var(--secondary-regular-active) !important;
}
::ng-deep .p-datatable-scrollable .p-datatable-frozen-tbody > tr > td {
  background: var(--contrast-inverse) !important;
}
::ng-deep .p-datatable-scrollable .p-datatable-frozen-tbody > tr:hover > td,
::ng-deep .p-datatable-scrollable .p-datatable-frozen-tbody > tr.pa-table-row-hovered > td {
  background: var(--secondary-regular-active) !important;
}
::ng-deep .p-datatable-scrollable .pa-table-checkbox-column,
::ng-deep .p-datatable-scrollable .pa-table-actions-column {
  z-index: 2;
}
::ng-deep .p-datatable-frozen-column-left:not(th),
::ng-deep .p-datatable-frozen-column:not(th) {
  background-color: inherit !important;
}
::ng-deep .p-datatable .p-datatable-thead > tr > th,
::ng-deep .p-datatable .p-datatable-tbody > tr > td {
  border-radius: 0;
  padding: 8px 12px;
}
::ng-deep .p-datatable .p-datatable-thead > tr:first-child > th:first-child {
  border-top-left-radius: 8px;
}
::ng-deep .p-datatable .p-datatable-thead > tr:first-child > th:last-child {
  border-top-right-radius: 8px;
}
::ng-deep .p-datatable .p-datatable-tbody > tr:last-child > td:first-child {
  border-bottom-left-radius: 8px;
}
::ng-deep .p-datatable .p-datatable-tbody > tr:last-child > td:last-child {
  border-bottom-right-radius: 8px;
}
::ng-deep .p-datatable-table-container {
  border-radius: 8px !important;
}
.pa-table-skeleton {
  border-radius: 8px;
  background: var(--contrast-inverse);
  border: 1px solid var(--secondary-subtle-hover);
  overflow: hidden;
  height: calc(100vh - 170px);
}
.pa-table-skeleton-header {
  display: flex;
  padding: 1rem;
  background: var(--p-datatable-header-cell-background);
  gap: 1rem;
  border-bottom: 1px solid var(--secondary-subtle-hover);
}
.pa-table-skeleton-rows {
  display: flex;
  flex-direction: column;
}
.pa-table-skeleton-row {
  display: flex;
  padding: 1rem;
  gap: 1rem;
  border-bottom: 1px solid var(--secondary-subtle-hover);
}
.pa-table-skeleton-row:last-child {
  border-bottom: none;
}
.pa-table-skeleton-row:nth-child(odd) {
  background-color: var(--secondary-regular-active);
}
.skeleton-item {
  background:
    linear-gradient(
      90deg,
      var(--secondary-subtle-default) 25%,
      var(--secondary-subtle-hover) 50%,
      var(--secondary-subtle-default) 75%);
  margin: 8px 0;
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
}
.skeleton-item.skeleton-header {
  height: 16px;
  flex: 1;
}
.skeleton-item.skeleton-cell {
  height: 16px;
  flex: 1;
}
.pa-table-pagination {
  padding-top: 8px;
}
.completed-task .content {
  text-decoration: line-through;
}
.completed-task .cell-content {
  opacity: 0.5;
}
.expired-task .content,
.expired-task .content-empty {
  color: var(--danger-regular-default);
}
.empty-template {
  overflow-x: auto;
  border-radius: 0 0 24px 24px;
}
.time-range-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.time-range-container .time-range-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
.time-range-container .time-total-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
.time-icon {
  font-size: 0.8rem;
  color: inherit;
  flex-shrink: 0;
}
.time-icon.time-icon-error {
  color: var(--danger-regular-default);
}
.time-range {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}
.time-range .time-link {
  color: var(--primary-subtle-inverse);
  text-decoration: none;
}
.time-range .time-link:hover {
  text-decoration: underline;
}
.time-range .time-separator {
  color: inherit;
  margin: 0 0.25rem;
}
.time-total {
  color: inherit;
}
.image-text-content {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.image-text-content .image-text-image {
  width: 16px;
  height: 16px;
  object-fit: cover;
  flex-shrink: 0;
}
.image-text-content .image-text-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.icon-text-content {
  display: block;
  width: 100%;
}
.icon-text-content .icon-text-icon {
  float: left;
  margin-top: 5px;
  margin-right: 8px;
  font-size: 12.5px;
}
.icon-text-content .icon-text-text {
  display: block;
  overflow-wrap: anywhere;
  white-space: normal;
  line-height: 22px;
}
.icon-text-content[data-severity=primary] .icon-text-icon {
  color: var(--primary-regular-default);
}
.icon-text-content[data-severity=success] .icon-text-icon {
  color: var(--success-regular-default);
}
.icon-text-content[data-severity=info] .icon-text-icon {
  color: var(--primary-subtle-inverse);
}
.icon-text-content[data-severity=warn] .icon-text-icon {
  color: var(--warning-regular-default);
}
.icon-text-content[data-severity=danger] .icon-text-icon {
  color: var(--danger-regular-default);
}
.icon-text-content[data-severity=secondary] .icon-text-icon {
  color: var(--secondary-regular-default);
}
.date-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 1.5em;
  width: 100%;
}
.date-container ion-icon {
  color: var(--ion-text-color);
  flex-shrink: 0;
  transition: opacity 0.2s ease;
}
.date-container .date-text {
  display: inline-block;
  transition: opacity 0.2s ease;
}
@media (min-width: 1199px) {
  .pa-table-bulk-bar-container.pa-table-bulk-bar-container--no-pagination {
    position: static;
    margin: 8px auto 0 auto;
  }
  .pa-table-bulk-bar.pa-table-bulk-bar--with-pagination {
    position: absolute;
    left: 0;
    bottom: 8px;
    right: 0;
    width: fit-content;
    margin: auto;
    z-index: 1000;
  }
}
/*# sourceMappingURL=pa-table.component.css.map */
